'use strict';

function closeGalleries() {
    $('.gallery.fullscreen').removeClass('show');
}

function slickGallery(selector) {

    $(selector).each(function() {

        let parentId = $(this).attr('id');

        let imagesCount = $('.gallery-thumb', this).length;
        let navSlides = (imagesCount > 7) ? 7 : imagesCount-1;

        let mobile = ($( window ).width() < 768);
        let multipleImages = (imagesCount > 7);

        let thumbnailsToShow  = 0;

        if (mobile) {
            thumbnailsToShow = (imagesCount > 2) ? 2 : 1;
        } else {
            if (multipleImages) {
                thumbnailsToShow = navSlides;
            } else {
                thumbnailsToShow = imagesCount;
            }
        }

        $(this).children('.gallery-boxes').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            centerMode: false,
            swipeToSlide: true,
            useCSS: false,
            asNavFor: multipleImages || mobile ? '#' + parentId + ' .gallery-nav' : false,
            variableWidth: false,
            infinite: true,
            useTransform: true,
            centerPadding: 0,
            cssEase: 'ease-out',
            lazyLoad: 'ondemand',
            mobileFirst: true,
            nextArrow: '<button type="button" class="slick-next"></button>',
            prevArrow: '<button type="button" class="slick-prev"></button>'
        });

        $(this).children('.gallery-nav').slick({
            slidesToShow: thumbnailsToShow,
            slidesToScroll: 1,
            asNavFor: '#' + parentId + ' .gallery-boxes',
            dots: false,
            arrows: false,
            centerMode: multipleImages || mobile,
            focusOnSelect: true,
            variableWidth: !multipleImages && !mobile,
            infinite: multipleImages || mobile,
            swipeToSlide: multipleImages || mobile,
            mobileFirst: true,
            centerPadding: 0,
            cssEase: 'ease-out'
        });

        if (!multipleImages && !mobile) {

            $(this).children('.gallery-boxes').on('beforeChange', function (event, slick, currentSlide, nextSlide) {

                $(this).parent().children('.gallery-nav').find('.slick-slide')
                    .removeClass('slick-active')
                    .removeClass('slick-current')
                    .eq(nextSlide)
                    .addClass('slick-active')
                    .addClass('slick-current');
            });

        }

        // On after fullscreen gallery slide change
        if ($(this).hasClass('fullscreen')) {
            $(this).children('.gallery-boxes').on('afterChange', function () {

                let title = $('.slick-current img', this).attr('title');

                $(this).parent().find('.gallery-caption span').html(
                    (title && title.length > 2) ? title : ''
                );

            });
        }


        //Reload YouTube videos to stop them on slide change
        $(this).children('.gallery-boxes').on('afterChange', function () {
            $('.video-gallery iframe').each(function () {
                var video = $(this).attr('src');
                video = video.replace('autoplay=1', 'autoplay=0');
                $(this).attr('src', '');
                $(this).attr('src', video);

            });
        });


    });

    $('.gallery:not(.video-gallery) a').on('click', function(e) {
        e.preventDefault();

        let slideno = $(this).parent().data('slick-index');
        let galleryId = $(this).data('gallery-id');

        let boxesCount = $(`#gallery-${galleryId}`).find('.gallery-boxes .gallery-box').length;

        if (boxesCount > 1) {
            $('#gallery-fullscreen-' + galleryId + ' .gallery-boxes').slick('slickGoTo', slideno, true);
        }

        $('#gallery-fullscreen-' + galleryId).addClass('show');

    });


    //Close on Escape or Close button
    $('.gallery-close').on('click', function() {
        closeGalleries();
    });
    $(document).keyup(function(e) {
        if (e.key === 'Escape') {
            closeGalleries();
        }
    });

}

export default slickGallery;